<script lang="ts">

    export let items: any[] = [];
    export let time = 30;

    let index = -1;
    let interval: number;
    let item: any;

    $: setupInterval(items, time);

    function setupInterval(items: any[], time: number): void {
        window.clearInterval(interval);
        if (items.length === 0) {
            index = -1;
            item = undefined;
            return;
        }
        interval = window.setInterval(next, time);
        next();
    }

    function next(): void {
        if (++index >= items.length) index = 0;
        item = items[index];
    }

</script>

{#if item}
    <slot {item} />
{/if}

